import axios from "axios";
import { Env } from "./common/models";

let _env: Env | null = null;

const getEnv = async (): Promise<Env> => {
  const res = await axios({
    method: "GET",
    baseURL: "",
    url: "/configs/application.json",
  });
  return res.data;
};

const ENV_NUM = {
  local: 1,
  dev: 1,
  qa: 1,
  debug: 1,
  stage: 2,
  production: 3,
};

export const env = async (): Promise<Env> => {
  if (!_env) {
    _env = await getEnv();
    // @ts-ignore
    _env.env_num = ENV_NUM[_env.env] || 1;
  }
  return _env;
};
